import { useEffect, useState } from "react";
import { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import heroImage from "../assets/lady-justice.jpg";
import parallaxImage from "../assets/nairobi-skyline.jpg";
import axios from "axios";




import commercial from "../assets/commercial-property.jpg";
import conveyancing from "../assets/land-law-conveyancing.jpg";
import criminal from "../assets/criminal law.webp";
import family from "../assets/family -law.webp";

import member1 from "../assets/team1.jpg";
import member2 from "../assets/team2.jpg";
import member3 from "../assets/about-section.jpg";
import member4 from "../assets/about-section.jpg";

// About Images 
import aboutImage1 from "../assets/aboutimage1.jpg";
import aboutImage2 from "../assets/aboutimage2.webp";
import aboutImage3 from "../assets/aboutimage3.jpg";

//Blog images
import blog1 from "../assets/about-hero.jpg";
import blog2 from "../assets/aboutimage1.jpg";
import blog3 from "../assets/aboutimage2.webp";
import blog4 from "../assets/aboutimage1.jpg";
//sectors we serve images
import realEstateImage from "../assets/real-estate-and-construction.jpg";
import smeImage from "../assets/smes.png";
import agricultureImage from "../assets/agriculture.png";
import transportImage from "../assets/logistics.png";
import hospitalityImage from "../assets/hospitality.webp";
import religiousImage from "../assets/religious.webp";
import familyImage from "../assets/family2.jpg";

//Unique Value Proposition Images
import uvpImage1 from "../assets/lady-justice.jpg";
import uvpImage from "../assets/about-hero-4.jpg";
import uvpImage3 from "../assets/aboutimage1.jpg";

// ── Shared useInView hook ─────────────────────────────────────────────
function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [threshold]);

  return [ref, inView];
}





// ── Why Choose Us data ────────────────────────────────────────────────
const wcuStats = [
  { value: "20+", label: "Years of Experience" },
  { value: "500+", label: "Cases Won" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "3", label: "Office Locations" },
];

const wcuReasons = [
  {
    icon: (
      <svg width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 010 4.94A3.745 3.745 0 0116.5 21a3.745 3.745 0 01-3.068-1.593 3.745 3.745 0 01-4.94 0A3.745 3.745 0 017.5 21a3.745 3.745 0 01-1.407-3.007 3.745 3.745 0 010-4.94A3.745 3.745 0 017.5 3a3.745 3.745 0 013.068 1.593 3.745 3.745 0 014.94 0A3.745 3.745 0 0121 12z" />
      </svg>
    ),
    title: "Proven Track Record",
    description: "Over two decades of courtroom wins and negotiated settlements across civil, criminal, and corporate law. Results speak louder than promises.",
  },
  {
    icon: (
      <svg width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-1a4 4 0 00-5.196-3.796M9 11a4 4 0 100-8 4 4 0 000 8zm0 2c-5.33 0-8 2.686-8 4v1h16v-1c0-1.314-2.67-4-8-4z" />
      </svg>
    ),
    title: "Client-First Approach",
    description: "You get a dedicated attorney, direct access, and updates every step of the way. Every case is treated with the urgency and care it deserves.",
  },
  {
    icon: (
      <svg width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0118 18a8.966 8.966 0 00-6 2.292m0-14.25v14.25" />
      </svg>
    ),
    title: "Deep Legal Expertise",
    description: "Our attorneys hold advanced degrees and specialize across multiple practice areas — from family law to high-stakes corporate litigation.",
  },
  {
    icon: (
      <svg width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5" />
      </svg>
    ),
    title: "Ethical & Transparent",
    description: "No hidden fees. No vague timelines. We give you a clear picture of your case, options, and costs — before you sign anything.",
  },
  {
    icon: (
      <svg width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253" />
      </svg>
    ),
    title: "Local Knowledge, National Reach",
    description: "Deeply rooted in Nairobi's legal landscape with a partner network across Kenya — giving your case both local advantage and wider reach.",
  },
  {
    icon: (
      <svg width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: "Available When It Matters",
    description: "Legal emergencies don't wait for business hours. Our team is reachable around the clock for urgent matters — time is often the difference.",
  },
];

// ── Our Team data — ──────────────────
const teamMembers = [
  {
    name: "John Doe",
    image: member1,
    link: "/team/john-doe",
  },
  {
    name: "Sarah Kimani",
    image: member2,
    link: "/team/sarah-kimani",
  },
  {
    name: "David Mwangi",
    image: member3,
    link: "/team/david-mwangi",
  },
  {
    name: "Grace Wanjiru",
    image: member4,
    link: "/team/grace-wanjiru",
  },
];




const blogs = [
  {
    title: "Understanding Property Law in Kenya",
    image: blog1,
    date: "12 March 2026",
    link: "/blog/property-law",
  },
  {
    title: "What to Do When Facing Criminal Charges",
    image: blog2,
    date: "05 February 2026",
    link: "/blog/criminal-charges",
  },
  {
    title: "Guide to Starting a Business Legally in Kenya",
    image: blog3,
    date: "18 January 2026",
    link: "/blog/business-law",
  },
  {
    title: "How Contracts Protect Your Business",
    image: blog4,
    date: "02 December 2025",
    link: "/blog/contracts",
  },
];
const avatarColors = [
  { bg: "#0B3D91", text: "#ffffff" },
  { bg: "#1e5cb3", text: "#ffffff" },
  { bg: "#dbeafe", text: "#0B3D91" },
  { bg: "#bfdbfe", text: "#0B3D91" },
];

// ── Why Choose Us sub-components ──────────────────────────────────────
function StatCard({ value, label, index, inView }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-8 px-4"
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(20px)",
        transition: `opacity 0.6s ease ${index * 0.1 + 0.2}s, transform 0.6s ease ${index * 0.1 + 0.2}s`,
      }}
    >
      <p className="text-4xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif", color: "#0B3D91" }}>
        {value}
      </p>
      <p className="mt-1 text-sm text-slate-500 tracking-wide text-center">{label}</p>
    </div>
  );
}

function ReasonCard({ icon, title, description, index, inView }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="relative rounded-2xl p-6 cursor-default"
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(32px)",
        transition: `opacity 0.6s ease ${index * 0.08 + 0.3}s, transform 0.6s ease ${index * 0.08 + 0.3}s, background 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease`,
        background: hovered ? "#0B3D91" : "#ffffff",
        border: `1.5px solid ${hovered ? "#0B3D91" : "#e2e8f0"}`,
        boxShadow: hovered ? "0 12px 32px rgba(11,61,145,0.18)" : "0 2px 8px rgba(0,0,0,0.04)",
      }}
    >
      <div
        className="mb-4 inline-flex items-center justify-center w-11 h-11 rounded-xl"
        style={{
          background: hovered ? "rgba(255,255,255,0.15)" : "#eff6ff",
          color: hovered ? "#ffffff" : "#0B3D91",
          transition: "background 0.3s ease, color 0.3s ease",
        }}
      >
        {icon}
      </div>
      <h3
        className="mb-2 text-base font-semibold"
        style={{ fontFamily: "'Playfair Display', serif", color: hovered ? "#ffffff" : "#1e293b", transition: "color 0.3s ease" }}
      >
        {title}
      </h3>
      <p className="text-sm leading-relaxed" style={{ color: hovered ? "rgba(255,255,255,0.82)" : "#64748b", transition: "color 0.3s ease" }}>
        {description}
      </p>
    </div>
  );
}

// ── Our Team card ──────────────────────────────────────
function TeamCard({ member, index, inView }) {
  return (
    <Link
      to={member.link}
      className="group relative overflow-hidden rounded-2xl shadow-lg"
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(40px)",
        transition: `opacity 0.8s ease ${index * 0.15}s, transform 0.8s ease ${index * 0.15}s`,
      }}
    >

      {/* IMAGE */}
      <img
        src={member.image}
        alt={member.name}
        className="w-full h-[500px] object-cover group-hover:scale-110 transition duration-[2000ms]"
      />

      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent"></div>

      {/* NAME */}
      <div className="absolute bottom-0 left-0 w-full p-6">
        <h3 className="text-white text-2xl font-semibold">
          {member.name}
        </h3>
      </div>

    </Link>
  );
}

function BlogCard({ blog }) {
  const imageUrl = blog.featured_image
  ? `http://localhost:5000${blog.featured_image}`
  : blog.image || blog.fallbackImage;

  return (
    <Link
      to={`/insights/${blog.slug}`}
      className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition duration-300"
    >
      {/* IMAGE */}
      <div className="overflow-hidden">
        <img
          src={imageUrl}
          alt={blog.title}
          className="w-full h-56 object-cover group-hover:scale-110 transition duration-700"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/600x400?text=No+Image";
          }}
        />
      </div>

      {/* CONTENT */}
      <div className="p-5">
        <h3 className="text-lg font-semibold text-gray-900 group-hover:text-[#0B3D91] transition">
          {blog.title}
        </h3>

        <p className="mt-2 text-sm text-gray-500">
  {blog.created_at
    ? new Date(blog.created_at).toDateString()
    : "No date"}
</p>
      </div>
    </Link>
  );
}
function ParallaxSection() {
  return (
    <section className="relative h-[60vh] overflow-hidden">
      
      {/* Background image */}
      <div
        className="absolute inset-0 bg-fixed bg-center bg-cover"
        style={{
          backgroundImage: `url(${parallaxImage})`,
        }}
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center text-center px-6">
        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-white">
            Trusted by Clients Across Kenya
          </h2>
          <p className="mt-4 text-gray-200 text-lg">
            Excellence. Integrity. Results.
          </p>
        </div>
      </div>
    </section>
  );
}

// ── Main Home component ───────────────────────────────────────────────
function Home() {
   const [posts, setPosts] = useState([]);
   useEffect(() => {
  axios
    .get("http://localhost:5000/api/posts")
    .then((res) => {
      setPosts(res.data);
    })
    .catch((err) => {
      console.error(err);
    });
}, []);
  
  

  const [count, setCount] = useState(0);
  const sectionRef = useRef(null);
  const hasAnimated = useRef(false);
  const [visible, setVisible] = useState(false);
  const aboutRef = useRef(null);
  const practiceRef = useRef(null);
  const [practiceVisible, setPracticeVisible] = useState(false);

  // Why Choose Us refs
  const [wcuStatsRef, wcuStatsInView] = useInView();
  const [wcuGridRef, wcuGridInView] = useInView();
  const [wcuHeadingRef, wcuHeadingInView] = useInView();

  // Our Team refs
  const [teamHeadingRef, teamHeadingInView] = useInView();
  const [teamGridRef, teamGridInView] = useInView(0.1);

  const practices = [
    { name: "Corporate & Commercial Law", image: commercial, link: "/services/commercial" },
    { name: "Conveyance & Real Estate", image: conveyancing, link: "/services/family" },
    { name: "Criminal Defence", image: criminal, link: "/services/criminal" },
    { name: "Family & Succession Law", image: family, link: "/services/banking" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) { setVisible(true); observer.disconnect(); }
      },
      { threshold: 0.3 }
    );
    if (aboutRef.current) observer.observe(aboutRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !hasAnimated.current) {
        hasAnimated.current = true;
        let start = 0;
        const target = 500;
        const step = target / (4000 / 30);
        const interval = setInterval(() => {
          start += step;
          if (start >= target) { setCount(target); clearInterval(interval); }
          else setCount(Math.floor(start));
        }, 16);
      }
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) { setPracticeVisible(true); observer.disconnect(); }
      },
      { threshold: 0.3 }
    );
    if (practiceRef.current) observer.observe(practiceRef.current);
    return () => observer.disconnect();
  }, []);


  const reasons = [
  "Our Areas Of Practice?",
  "Conveyance and Real Esate",
  "Family and Succession Law",
  "General Legal Consultancy",
  "Corporate and Commercial Law",
  "Litigation and Dispute Resolution",
  "Criminal Defense",
];

const [displayText, setDisplayText] = useState("");
const [reasonIndex, setReasonIndex] = useState(0);
const [isDeleting, setIsDeleting] = useState(false);

useEffect(() => {
  const currentText = reasons[reasonIndex];
  const speed = isDeleting ? 40 : 80;

  const timer = setTimeout(() => {
    if (!isDeleting) {
      setDisplayText(currentText.substring(0, displayText.length + 1));

      if (displayText === currentText) {
        setTimeout(() => setIsDeleting(true), 1200);
      }
    } else {
      setDisplayText(currentText.substring(0, displayText.length - 1));

      if (displayText === "") {
        setIsDeleting(false);
        setReasonIndex((prev) => (prev + 1) % reasons.length);
      }
    }
  }, speed);

  return () => clearTimeout(timer);
}, [displayText, isDeleting, reasonIndex]);

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,400&family=DM+Sans:wght@300;400;500&display=swap"
        rel="stylesheet"
      />

      {/* ================= HERO ================= */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center scale-105 animate-slowZoom"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/30" />
        <div className="relative z-10 max-w-4xl px-6 text-white text-center animate-fadeUp">
          <h1 className="text-4xl md:text-6xl font-dancing-script leading-tight ">
            Trusted Legal Solutions for Individuals & Businesses
          </h1>
          <p className="mt-6 text-lg font-dancing-script md:text-xl text-gray-200">
            We deliver expert legal services with integrity, professionalism, and proven results.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/contact" className="bg-[#0B3D91] px-6 py-3 rounded-lg font-semibold hover:bg-blue-800 transition duration-300">
              Book Consultation
            </Link>
            <Link to="/about" className="border border-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-[#0B3D91] transition duration-300">
              Learn more
            </Link>
          </div>
          <div className="mt-10 flex justify-center">
  <h2 className="text-2xl md:text-4xl font-semibold text-blue-300 h-[50px] text-center">
    {displayText}
    <span className="animate-pulse">|</span>
  </h2>
</div>
        </div>
        
      </section>
      
      

      {/* ================= ABOUT ================= */}
<section
  ref={(el) => {
    aboutRef.current = el;
    sectionRef.current = el;
  }}
  className="bg-white py-24 px-6 overflow-hidden"
>
  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

    {/* LEFT CONTENT */}
    <div
      className={`transition-all duration-[1800ms] ease-out ${
        visible
          ? "opacity-100 translate-x-0"
          : "opacity-0 -translate-x-20"
      }`}
    >

      {/* SMALL TOP TEXT */}
      <div className="flex items-center gap-4 mb-8">

        <div className="w-20 h-[2px] bg-[#0B3D91]"></div>

        <p className="text-[#0B3D91] text-lg tracking-wide">
          Let’s Get Acquainted
        </p>

      </div>

      <h2 className="text-2xl md:text-3xl font-bold tracking-wide text-gray-900 leading-tight">
  A LETTER FROM OUR MANAGING ADVOCATE
</h2>
      {/* PARAGRAPHS */}
      <div className="mt-8 space-y-6 text-gray-600 leading-relaxed text-lg">

        <p className="text-gray-700 leading-relaxed">
  <span className="italic block mb-4">
    To the client who refuses to be just another file number,
  </span>

  <span>
    I founded <strong>GATI & CO. ADVOCATES</strong> because I grew tired of a legal industry that confuses 
    complexity with competence. Too many firms hide behind archaic language, slow motion, and 
    emotional distance. They forget that behind every dispute is a disrupted life, a stalled business, or 
    a family in anguish.
  </span>
</p>

       <p className="text-gray-700 leading-relaxed">
  The name <strong>Gati</strong> is deliberate. It means{" "}
  
  <span className="italic">movement, direction,</span> and{" "}
  
  <span className="italic">flow</span> in several local tongues.
  
  Because law should never be a static wall — it should be a moving force
  that carries you toward resolution, justice, or prosperity.
</p>

        <p>
At this firm, you will not find marble lobbies or unreachable senior partners. You will find me or 
my qualified associates — accessible, prepared, and deeply invested in your outcome. We charge 
fairly. We communicate clearly. We fight ferociously when needed, and negotiate wisely when 
possible.
        </p>

        <p className="text-gray-700 leading-relaxed">
  <span className="block mb-4">
    Welcome to a different kind of law firm.
  </span>

  <span className="block font-bold">
    Advocate Gati
  </span>

  <span className="block italic">
    Principal, GATI & CO. ADVOCATES
  </span>
</p>

      </div>

    </div>

    {/* RIGHT IMAGES */}
    <div
      className={`relative transition-all delay-300 duration-[1800ms] ease-out ${
        visible
          ? "opacity-100 translate-x-0"
          : "opacity-0 translate-x-20"
      }`}
    >

      {/* RIGHT IMAGES */}
<div
  className={`relative transition-all delay-300 duration-[1800ms] ease-out ${
    visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-20"
  }`}
>
  <div className="flex gap-6 items-start">

    {/* LEFT IMAGE (lower + shorter) */}
    <div className="mt-24 w-1/2">
      <img
        src={aboutImage1}
        alt="Law Firm"
        className="w-full h-[300px] object-cover rounded-2xl shadow-xl"
      />
    </div>

    {/* RIGHT IMAGE (higher + taller) */}
    <div className="w-1/2">
      <img
        src={aboutImage2}
        alt="Legal Team"
        className="w-full h-[440px] object-cover rounded-2xl shadow-xl"
      />
    </div>

  </div>

  {/* BOTTOM IMAGE (slightly offset too for balance) */}
  <div className="mt-6 ml-10">
    <img
      src={aboutImage3}
      alt="Office"
      className="w-[90%] h-[260px] object-cover rounded-2xl shadow-xl"
    />
  </div>
</div>
    </div>

  </div>
</section>

      {/* ================= AREAS OF PRACTICE ================= */}
      <section ref={practiceRef} className="bg-gray-50 py-20 px-6 overflow-hidden">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Areas of Practice</h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            We provide expert legal services across a wide range of practice areas.
          </p>
          <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-4 gap-8">
            {practices.map((item, index) => (
              <Link
                key={index}
                to={item.link}
                className={`group relative overflow-hidden rounded-xl shadow-lg transform transition-all duration-[1200ms] ease-out ${practiceVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <img src={item.image} alt={item.name} className="w-full h-56 object-cover scale-100 group-hover:scale-110 transition duration-[2000ms]" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition duration-500" />
                <h3 className="absolute bottom-4 left-4 text-white text-lg font-semibold">{item.name}</h3>
              </Link>
            ))}
          </div>
          <div
            className={`mt-12 transition-all duration-[1200ms] ${practiceVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
            style={{ transitionDelay: "800ms" }}
          >
            <Link to="/services" className="inline-block bg-[#0B3D91] text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition duration-300">
              Learn More
            </Link>
          </div>
        </div>
      </section>
      {/* ================= UNIQUE VALUE PROPOSITION ================= */}
<section
  className="relative py-28 px-6 md:px-16 bg-fixed bg-center bg-cover overflow-hidden"
  style={{
    backgroundImage: `url(${uvpImage})`,
  }}
>

  {/* LIGHT OVERLAY */}
  <div className="absolute inset-0 bg-white/20 backdrop-blur-[1px]"></div>

  {/* CONTENT */}
  <div className="relative z-10 max-w-7xl mx-auto">

    {/* SECTION HEADING */}
    <div className="text-center mb-20">

      <p className="text-[#0B3D91] uppercase tracking-[6px] font-semibold mb-4">
        Our Unique Value Proposition
      </p>

      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] mb-6">
        Why Rational Clients Choose GATI & CO.
      </h2>

      <p className="max-w-3xl mx-auto text-[#0B1C39]/80 text-lg leading-relaxed">
        A law firm intentionally built to solve the frustrations clients commonly
        experience with traditional legal practice.
      </p>

    </div>

    {/* GLASS CARDS */}
    <div className="grid lg:grid-cols-2 gap-8">

      {/* CARD */}
      <div className="group bg-white/35 backdrop-blur-md border border-white/40 rounded-[28px] p-8 shadow-xl hover:bg-white/45 hover:-translate-y-2 transition-all duration-500">

        <p className="text-red-600 text-sm uppercase tracking-[4px] mb-4 font-semibold">
          Client Fear
        </p>

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-6">
          “My lawyer never picks up calls.”
        </h3>

        <div className="w-14 h-[2px] bg-[#0B3D91] mb-6 group-hover:w-full transition-all duration-500"></div>

        <p className="text-[#0B1C39]/80 leading-relaxed text-lg">
          Dedicated response within 4 business hours by call, text, or email.
        </p>

      </div>

      {/* CARD */}
      <div className="group bg-white/35 backdrop-blur-md border border-white/40 rounded-[28px] p-8 shadow-xl hover:bg-white/45 hover:-translate-y-2 transition-all duration-500">

        <p className="text-red-600 text-sm uppercase tracking-[4px] mb-4 font-semibold">
          Client Fear
        </p>

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-6">
          “I don’t understand legal jargon.”
        </h3>

        <div className="w-14 h-[2px] bg-[#0B3D91] mb-6 group-hover:w-full transition-all duration-500"></div>

        <p className="text-[#0B1C39]/80 leading-relaxed text-lg">
          Every advice is explained in plain English or Kiswahili with a translation note.
        </p>

      </div>

      {/* CARD */}
      <div className="group bg-white/35 backdrop-blur-md border border-white/40 rounded-[28px] p-8 shadow-xl hover:bg-white/45 hover:-translate-y-2 transition-all duration-500">

        <p className="text-red-600 text-sm uppercase tracking-[4px] mb-4 font-semibold">
          Client Fear
        </p>

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-6">
          “My matter is too small for a big firm.”
        </h3>

        <div className="w-14 h-[2px] bg-[#0B3D91] mb-6 group-hover:w-full transition-all duration-500"></div>

        <p className="text-[#0B1C39]/80 leading-relaxed text-lg">
          No matter is too small. We treat Sh10,000 disputes with the same rigor as Sh1M cases.
        </p>

      </div>

      {/* CARD */}
      <div className="group bg-white/35 backdrop-blur-md border border-white/40 rounded-[28px] p-8 shadow-xl hover:bg-white/45 hover:-translate-y-2 transition-all duration-500">

        <p className="text-red-600 text-sm uppercase tracking-[4px] mb-4 font-semibold">
          Client Fear
        </p>

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-6">
          “I’m afraid of hidden costs.”
        </h3>

        <div className="w-14 h-[2px] bg-[#0B3D91] mb-6 group-hover:w-full transition-all duration-500"></div>

        <p className="text-[#0B1C39]/80 leading-relaxed text-lg">
          Upfront fee estimates. No surprise billings. Written retainer agreements.
        </p>

      </div>

      {/* CARD */}
      <div className="group bg-white/35 backdrop-blur-md border border-white/40 rounded-[28px] p-8 shadow-xl hover:bg-white/45 hover:-translate-y-2 transition-all duration-500">

        <p className="text-red-600 text-sm uppercase tracking-[4px] mb-4 font-semibold">
          Client Fear
        </p>

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-6">
          “Lawyers delay intentionally.”
        </h3>

        <div className="w-14 h-[2px] bg-[#0B3D91] mb-6 group-hover:w-full transition-all duration-500"></div>

        <p className="text-[#0B1C39]/80 leading-relaxed text-lg">
          Internal deadline tracking. You get reminders and proactive follow-ups, not excuses.
        </p>

      </div>

      {/* FEATURE CARD */}
      <div className="group bg-[#0B3D91]/75 backdrop-blur-md border border-white/20 rounded-[28px] p-8 shadow-2xl hover:bg-[#0B3D91]/85 hover:-translate-y-2 transition-all duration-500">

        <p className="text-yellow-300 text-sm uppercase tracking-[4px] mb-4 font-semibold">
          Emergency Action
        </p>

        <h3 className="text-2xl font-bold text-white mb-6">
          “I need fast action — not meetings.”
        </h3>

        <div className="w-14 h-[2px] bg-yellow-400 mb-6 group-hover:w-full transition-all duration-500"></div>

        <p className="text-white/90 leading-relaxed text-lg">
          Emergency retainer option for same-day filing or urgent legal letter drafting.
        </p>

      </div>

    </div>

  </div>

</section>

      {/* ================= OUR TEAM ================= */}
      <section
        className="relative overflow-hidden py-24 px-4"
        style={{ background: "#ffffff", fontFamily: "'DM Sans', sans-serif" }}
      >
        {/* Dot pattern background */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage: "radial-gradient(circle, #dbeafe 1px, transparent 1px)",
            backgroundSize: "28px 28px",
            opacity: 0.45,
          }}
        />
        {/* Top-right blob */}
        <div
          className="pointer-events-none absolute -top-20 -right-20 w-72 h-72 rounded-full"
          style={{ background: "radial-gradient(circle, #bfdbfe 0%, transparent 70%)", opacity: 0.5 }}
        />

        <div className="relative z-10 max-w-6xl mx-auto">

          {/* Heading */}
          <div
            ref={teamHeadingRef}
            className="text-center max-w-xl mx-auto mb-14"
            style={{
              opacity: teamHeadingInView ? 1 : 0,
              transform: teamHeadingInView ? "translateY(0)" : "translateY(24px)",
              transition: "opacity 0.7s ease, transform 0.7s ease",
            }}
          >
            <span
              className="inline-block mb-4 text-xs font-semibold uppercase tracking-[0.22em] px-4 py-1.5 rounded-full"
              style={{ background: "#dbeafe", color: "#0B3D91" }}
            >
              Meet the team
            </span>
            <h2
              className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              The attorneys in{" "}
              <span className="italic" style={{ color: "#0B3D91" }}>your corner.</span>
            </h2>
            <p className="mt-4 text-base text-slate-500 leading-relaxed">
              Experienced, dedicated, and driven by results. Our team brings together
              specialists across every area of law — so you always have the right
              person fighting for you.
            </p>
          </div>

          {/* Team grid */}
          <div
            ref={teamGridRef}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          >
            {teamMembers.map((member, i) => (
              <TeamCard key={member.name} member={member} index={i} inView={teamGridInView} />
            ))}
          </div>

          {/* CTA */}
          <div
            className="mt-14 text-center"
            style={{ opacity: teamGridInView ? 1 : 0, transition: "opacity 0.8s ease 0.8s" }}
          >
            <p className="text-sm text-slate-400 mb-4">Our full team of legal professionals is ready to assist you.</p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full text-sm font-medium text-white transition-all duration-200 hover:bg-blue-800"
              style={{ background: "#0B3D91" }}
            >
              Get in touch
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </div>
      </section>
      <ParallaxSection />
      {/* ================= SECTOR EXPERTISE ================= */}
<section className="py-24 px-6 md:px-16 bg-[#F8F8F8]">

  <div className="max-w-7xl mx-auto">

    {/* SECTION HEADER */}
    <div className="text-center mb-20">

      <p className="text-yellow-600 font-semibold uppercase tracking-[5px] mb-4">
        Sector Expertise
      </p>

      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] mb-6">
        Industries We Serve
      </h2>

      <p className="max-w-3xl mx-auto text-gray-600 text-lg leading-relaxed">
        We are not generalists by accident. Our firm has developed practical,
        industry-specific legal experience across sectors that shape businesses,
        communities, and everyday life.
      </p>

    </div>

    {/* CARDS GRID */}
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

      {/* CARD 1 */}
      <div className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">

        <div className="p-8">

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-5">
            Real Estate & Construction
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Advising developers, contractors, investors, and landowners on land acquisition,
            contractor disputes, NEMA compliance, development agreements,
            and construction-related legal matters.
          </p>

        </div>

        <div className="overflow-hidden">
          <img
            src={realEstateImage}
            alt="Real Estate & Construction"
            className="w-full h-[260px] object-cover group-hover:scale-110 transition duration-700"
          />
        </div>

      </div>

      {/* CARD 2 */}
      <div className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">

        <div className="p-8">

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-5">
            SMEs & Retail Trade
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Supporting businesses with company registration, lease agreements,
            commercial contracts, compliance matters, and debt recovery solutions
            tailored for growing enterprises.
          </p>

        </div>

        <div className="overflow-hidden">
          <img
            src={smeImage}
            alt="SMEs & Retail Trade"
            className="w-full h-[260px] object-cover group-hover:scale-110 transition duration-700"
          />
        </div>

      </div>

      {/* CARD 3 */}
      <div className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">

        <div className="p-8">

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-5">
            Agriculture
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Providing legal guidance on land succession, cooperative disputes,
            agricultural leases, land ownership structures, and farming-related transactions.
          </p>

        </div>

        <div className="overflow-hidden">
          <img
            src={agricultureImage}
            alt="Agriculture"
            className="w-full h-[260px] object-cover group-hover:scale-110 transition duration-700"
          />
        </div>

      </div>

      {/* CARD 4 */}
      <div className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">

        <div className="p-8">

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-5">
            Transport & Logistics
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Assisting transport operators and logistics businesses with insurance claims,
            accident liability disputes, commercial agreements, and regulatory compliance.
          </p>

        </div>

        <div className="overflow-hidden">
          <img
            src={transportImage}
            alt="Transport & Logistics"
            className="w-full h-[260px] object-cover group-hover:scale-110 transition duration-700"
          />
        </div>

      </div>

      {/* CARD 5 */}
      <div className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">

        <div className="p-8">

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-5">
            Hospitality
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Advising hotels, restaurants, and hospitality businesses on licenses,
            lease renewals, employment matters, compliance obligations,
            and operational legal support.
          </p>

        </div>

        <div className="overflow-hidden">
          <img
            src={hospitalityImage}
            alt="Hospitality"
            className="w-full h-[260px] object-cover group-hover:scale-110 transition duration-700"
          />
        </div>

      </div>

      {/* CARD 6 */}
      <div className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">

        <div className="p-8">

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-5">
            Religious Organizations & CBOs
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Helping churches, NGOs, trusts, and community-based organizations with
            registration, governance documentation, compliance,
            and institutional legal structuring.
          </p>

        </div>

        <div className="overflow-hidden">
          <img
            src={religiousImage}
            alt="Religious Organizations"
            className="w-full h-[260px] object-cover group-hover:scale-110 transition duration-700"
          />
        </div>

      </div>

      {/* CARD 7 */}
      <div className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 lg:col-span-1 md:col-span-1">

        <div className="p-8">

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-5">
            Individuals & Families
          </h3>

          <p className="text-gray-600 leading-relaxed ">
            Providing trusted legal support in wills, divorce, land inheritance,
            succession planning, tenancy disputes, and family-related legal matters
            with sensitivity, clarity, and strategic guidance.
          </p>

        </div>

        <div className="overflow-hidden">
          <img
            src={familyImage}
            alt="Individuals & Families"
            className="w-full h-[260px] object-cover group-hover:scale-110 transition duration-700"
          />
        </div>

      </div>

    </div>

  </div>

</section>

      {/* ================= WHY CHOOSE US ================= */}
      <section
        className="relative overflow-hidden py-24 px-4"
        style={{ background: "#f0f5ff", fontFamily: "'DM Sans', sans-serif" }}
      >
        <div
          className="pointer-events-none absolute -top-28 -right-28 w-80 h-80 rounded-full"
          style={{ background: "radial-gradient(circle, #bfdbfe 0%, transparent 70%)", opacity: 0.7 }}
        />
        <div
          className="pointer-events-none absolute -bottom-24 -left-24 w-72 h-72 rounded-full"
          style={{ background: "radial-gradient(circle, #dbeafe 0%, transparent 70%)", opacity: 0.5 }}
        />

        <div className="relative z-10 max-w-6xl mx-auto">

          {/* Heading */}
          <div
            ref={wcuHeadingRef}
            className="mb-14 text-center max-w-2xl mx-auto"
            style={{
              opacity: wcuHeadingInView ? 1 : 0,
              transform: wcuHeadingInView ? "translateY(0)" : "translateY(24px)",
              transition: "opacity 0.7s ease, transform 0.7s ease",
            }}
          >
            <span
              className="inline-block mb-4 text-xs font-semibold uppercase tracking-[0.22em] px-4 py-1.5 rounded-full"
              style={{ background: "#dbeafe", color: "#0B3D91" }}
            >
              Why choose us
            </span>
            <h2
              className="text-4xl md:text-5xl font-bold leading-tight text-slate-900"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Legal excellence you can{" "}
              <span className="italic" style={{ color: "#0B3D91" }}>rely on.</span>
            </h2>
            <p className="mt-4 text-base text-slate-500 leading-relaxed">
              We've built our reputation one case at a time — through diligence,
              integrity, and an unrelenting focus on outcomes that matter to you.
            </p>
          </div>

          {/* Stats strip */}
          <div
            ref={wcuStatsRef}
            className="mb-12 rounded-2xl overflow-hidden"
            style={{ background: "#ffffff", border: "1.5px solid #dbeafe", boxShadow: "0 4px 24px rgba(11,61,145,0.08)" }}
          >
            <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-blue-50">
              {wcuStats.map((s, i) => (
                <StatCard key={s.label} {...s} index={i} inView={wcuStatsInView} />
              ))}
            </div>
          </div>

          {/* Reasons grid */}
          <div ref={wcuGridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {wcuReasons.map((r, i) => (
              <ReasonCard key={r.title} {...r} index={i} inView={wcuGridInView} />
            ))}
          </div>

          {/* CTA */}
          <div
            className="mt-14 flex flex-col sm:flex-row items-center gap-3 justify-center"
            style={{ opacity: wcuGridInView ? 1 : 0, transition: "opacity 0.8s ease 0.9s" }}
          >
            <Link
              to="/contact"
              className="px-8 py-3 rounded-full text-sm font-medium text-white transition-all duration-200 hover:bg-blue-800"
              style={{ background: "#0B3D91" }}
            >
              Book a free consultation
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full text-sm font-medium transition-all duration-200 hover:bg-blue-50"
              style={{ border: "1.5px solid #93c5fd", color: "#0B3D91" }}
            >
              Meet our attorneys →
            </Link>
          </div>
          {/* ================= BLOGS ================= */}
<section className="bg-white py-24 px-6">
  <div className="max-w-7xl mx-auto">

    {/* HEADER */}
    <div className="text-center mb-14">
      <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
        Latest Legal Insights
      </h2>
      <p className="mt-4 text-gray-500 max-w-2xl mx-auto">
        Stay updated with insights, legal guides, and expert opinions from our attorneys.
      </p>
    </div>

    {/* GRID */}
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">

      {posts.length > 0 ? (
        posts.map((post) => (
          <BlogCard key={post.id} blog={post} />
        ))
      ) : (
        <p className="text-center text-gray-500 col-span-4">
          No posts available yet.
        </p>
      )}

    </div>

    {/* BUTTON */}
    <div className="mt-14 text-center">
      <Link
        to="/insights"
        className="inline-block bg-[#0B3D91] text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition"
      >
        View More Articles
      </Link>
    </div>

  </div>
</section>
        </div>
      </section>
    </>
  );
}

export default Home;
